import { createAction, props } from '@ngrx/store'
import { UserContactInfo } from './submit.reducer'

export const RESET_PASSENGERS = 'RESET_PASSENGERS'
export const SET_CONTACT_NUMBER = 'SET_CONTACT_NUMBER'
export const SET_CONTACT_INFO = 'SET_CONTACT_INFO'

export const setResetPassengers = createAction(RESET_PASSENGERS)

export const setContactNumber = createAction(
  SET_CONTACT_NUMBER,
  props<{ payload: string }>()
)

/**
 * `review-and-submit` owns the contact form locally, but the call payload is
 * assembled from the store by `calls.selectors` and the wizard gates on
 * `selectIsSubmitValid`, so the value is mirrored here as it changes.
 */
export const setContactInfo = createAction(
  SET_CONTACT_INFO,
  props<{ payload: UserContactInfo }>()
)
